import StackedList from '@/components/StackedList'
import { useContributions } from '@/hooks'
import type { Contribution } from '@/services/contribution/contribution'
import { ContributionListHeader, ContributionListItem } from '@/components/ContributionListItem'

export default function ContributionList() {
  const { data, isPending, error } = useContributions()

  if (isPending) return <div>Loading...</div>
  if (error) return <div>Error: {(error as Error).message}</div>

  if (!data.contributions || data.contributions.length === 0) {
    return null
  }

  return (
    <StackedList
      Header={ContributionListHeader}
      renderItem={({ item: contribution }: { item: Contribution }) => (
        <ContributionListItem key={contribution.id} contribution={contribution} />
      )}
      data={data?.contributions}
    />
  )
}
